import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66e8bb2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]


import { OnlineMember } from '@/models/members.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildMember',
  props: {
  member: OnlineMember
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.member?.id,
    class: _normalizeClass({ offline: __props.member?.status === 1 })
  }, _toDisplayString(__props.member?.username), 11, _hoisted_1))
}
}

})